import { Chip } from '@material-ui/core';
import clsx from 'clsx';

const mapStatusToColor = status => {
  switch (status) {
    case 'success':
      return 'bg-green-100 text-green-500 border-green-300';
    case 'danger':
      return 'bg-red-100 text-red-500 border-red-300';
    case 'warning':
      return 'bg-orange-100 text-orange-500 border-orange-300';
    case 'info':
      return 'bg-light-blue-100 text-light-blue-500 border-light-blue-300';
    default:
      return 'bg-gray-300 text-gray-600 border-gray-400';
  }
};

const CustomBadge = ({ content, status, customClassName }) => {
  const className = mapStatusToColor(status);

  return (
    <Chip
      variant="outlined"
      color="secondary"
      label={content}
      className={clsx('p-4 font-semibold tracking-wider', className, customClassName)}
    />
  );
};

export default CustomBadge;
